import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const COHORTS_ENDPOINTS = {
  V2: createEndpoints('v2', {
    COHORTS: '/engagements/cohorts/',
    COHORT_BY_ID: (id: number | string) => `/engagements/cohorts/${id}/`,
    COHORT_EXPERTS: (id: number | string) => `/engagements/cohorts/${id}/experts/`,
    COHORT_EXPERT_BY_ID: (cohortId: number | string, expertId: number | string) => `/engagements/cohorts/${cohortId}/experts/${expertId}/`,
    COHORT_LOGS: (id: number | string) => `/engagements/cohorts/${id}/logs/`,
  }),
} as const;
